export const aboutData = {
  hero: {
    title: "关于媚肉之香",
    subtitle: "以香之名，唤醒你的内在魅力",
    image: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20fragrance%20brand%20studio%20with%20perfume%20bottles%20on%20marble%20table%2C%20warm%20golden%20ambient%20light%2C%20oriental%20aesthetic%20with%20minimalist%20interior%2C%20sophisticated%20atmosphere%2C%20editorial%20photography&width=1600&height=700&seq=about-hero-brand&orientation=landscape",
  },
  brandIntro: {
    title: "品牌介绍",
    paragraphs: [
      "媚肉之香诞生于对东方香氛文化的深刻热爱与对现代护肤科学的执着探索。我们的创始团队由资深调香师、皮肤科专家和东方文化研究者组成，共同怀揣一个梦想：将千年香道智慧融入当代生活，让每一位使用者都能在香气中找到自己的独特魅力。",
      "品牌名\"媚肉之香\"源自东方古典美学中对于女性魅力的诗意描绘。\"媚\"非媚俗，而是由内而外散发的自信与吸引；\"肉\"非肉体，而是最真实的肌肤与感知；\"香\"则是贯穿一切的灵魂——它既是嗅觉上的享受，也是精神上的净化。",
      "我们相信，真正的魅力不是伪装，而是唤醒——唤醒肌肤最原始的感知力，唤醒内心深处被遗忘的自信，让每一位使用者都能在自己的气息中，找到最真实、最动人的自己。",
    ],
  },
  philosophy: {
    title: "品牌理念",
    items: [
      {
        icon: "ri-leaf-line",
        title: "天然为本",
        description: "严选全球优质天然原料，拒绝人工合成香料，让每一缕香气都纯净自然，与肌肤和谐共生。",
      },
      {
        icon: "ri-history-line",
        title: "传承创新",
        description: "尊重千年东方香道智慧，融合现代调香科学与护肤科技，在传承中不断创新突破。",
      },
      {
        icon: "ri-heart-line",
        title: "以香养心",
        description: "香气不仅是外在的装饰，更是内在的滋养。我们关注香气对情绪与心灵的积极影响。",
      },
      {
        icon: "ri-shield-star-line",
        title: "品质至上",
        description: "从原料采购到生产工艺，每一个环节都严格把控，只为呈现最完美的感官体验。",
      },
    ],
  },
  timeline: [
    { year: "2017", event: "三位创始人在杭州西湖畔相遇，萌生创立东方香氛品牌的想法" },
    { year: "2018", event: "完成初步配方研发，与法国格拉斯调香学院建立合作" },
    { year: "2019", event: "媚肉之香品牌正式成立，首款香氛「暗夜玫瑰」问世" },
    { year: "2020", event: "推出肌肤养护系列，确立「以香养肤」产品理念" },
    { year: "2021", event: "荣获中国美妆产业年度新锐品牌奖" },
    { year: "2022", event: "全国门店突破15家，线上商城正式运营" },
    { year: "2023", event: "推出限定礼盒系列，品牌影响力持续增长" },
    { year: "2024", event: "客户满意度达98%，覆盖全国30+城市" },
  ],
  reputation: {
    title: "口碑评价",
    reviews: [
      {
        name: "林女士",
        location: "上海",
        rating: 5,
        content: "暗夜玫瑰是我用过最迷人的玫瑰香！不落俗套，深沉又有层次感。每次喷上它出门，都能收到身边人的赞美。媚肉之香的香氛真的有一种说不上来的高级感。",
        product: "暗夜玫瑰",
      },
      {
        name: "陈女士",
        location: "北京",
        rating: 5,
        content: "沉香润体乳的神奇在于，它不仅滋润效果超好，关键是那个淡淡的沉木香可以持续一整天！以前用的身体乳香味很快就散了，这款真的不一样。",
        product: "沉香润体乳",
      },
      {
        name: "王女士",
        location: "杭州",
        rating: 5,
        content: "被闺蜜安利的品牌，入了初见体验礼盒。四款香都试了一遍，最后选了桂月凝香。桂花香太温柔了，喷上心情都会变好。已经推荐给身边的同事了！",
        product: "初见·香氛体验礼盒",
      },
      {
        name: "张女士",
        location: "深圳",
        rating: 4,
        content: "玫瑰精华油用了一个月，皮肤真的变细腻了。吸收很快不油腻，而且玫瑰的香味非常治愈。晚上的护肤变成了一种享受。会回购！",
        product: "玫瑰精华油",
      },
      {
        name: "李女士",
        location: "成都",
        rating: 5,
        content: "送给妈妈做生日礼物的禅意礼盒，她特别喜欢！说檀香护手霜味道很高级，润体乳也很滋润。妈妈说这是她收到过最有心意的礼物。",
        product: "禅意·身心养护礼盒",
      },
    ],
  },
  contact: {
    title: "联系我们",
    description: "我们期待与您的每一次相遇。无论您有任何问题、建议或合作意向，都欢迎随时与我们联系。",
    address: "浙江省杭州市西湖区灵隐路18号 媚肉之香品牌中心",
    phone: "0571-8888-6666",
    email: "hello@meirouzhixiang.com",
    hours: "周一至周五 9:00 - 18:00",
    socials: [
      { name: "微信公众号", value: "媚肉之香" },
      { name: "微博", value: "@媚肉之香官方" },
      { name: "小红书", value: "@媚肉之香" },
    ],
  },
};